import StopSerializer from "./StopSerializer";
import OtherChargesSerializer from "./OtherChargesSerializer";
import MovementSerializer from "./MovementSerializer";
import { nullCheck } from "../utils/dataHelpers";
import { parseMcleodDate } from "../utils/dateHelpers";

export default class LoadSerializer {
  static serialize(data) {
    const payload = {
      ...data,
      id: data.id,
      commodity: data.commodity,
      stops: data.stops.map(stop => StopSerializer.serialize(stop)),
      otherCharges: data.otherCharges.map(otherCharge => OtherChargesSerializer.serialize(otherCharge)),
      revenue_code_id: data.revenueCodeId,
      weight: data.weight,
      bill_distance: data.miles,
      temperature_min: data.minTemp,
      temperature_max: data.maxTemp,
      order_type_id: data.orderTypeId ? data.orderTypeId : undefined,
      freight_charge_n: data.customerLinehaul,
      curr_movement_id: data.movementId,
      movements: [
        {
          ...data.movements[0],
          brokerage_status: data.brokerageStatus,
          override_targetpay: data.targetPay,
          override_max_pay: data.maxPay,
          override_pay_amt_n: data.carrierLinehaul,
          override_payee_id: data.payeeId,
          xfer2settle_date: data.settlementDate
        }
      ],
      equipment_type_id: data.equipmentTypeId
    };

    const customProperties = [
      "revenueCodeId",
      "brokerageStatus",
      "brokerageStatusDesc",
      "miles",
      "targetPay",
      "maxPay",
      "minTemp",
      "maxTemp",
      "orderTypeId",
      "customerLinehaul",
      "carrierLinehaul",
      "movementId",
      "settlementDate",
      "originCity",
      "originState",
      "originArrivEarly",
      "originArriveLate",
      "destinationCity",
      "destinationState",
      "destinationArriveEarly",
      "destinationArriveLate",
      "equipmentTypeId"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      id: data.id,
      commodity: data.commodity,
      stops: data.stops.map(stop => StopSerializer.deSerialize(stop)),
      otherCharges: data.otherCharges ? data.otherCharges.map(oc => OtherChargesSerializer.deSerialize(oc)) : [],
      revenueCodeId: data.revenue_code_id,
      brokerageStatus: nullCheck(data, null, "movements", "0", "brokerage_status"),
      weight: data.weight,
      miles: data.bill_distance,
      targetPay: nullCheck(data, 0, "movements", "0", "override_targetpay"),
      maxPay: nullCheck(data, 0, "movements", "0", "override_max_pay"),
      minTemp: data.temperature_min,
      maxTemp: data.temperature_max,
      orderTypeId: data.order_type_id,
      customerLinehaul: data.freight_charge_n,
      carrierLinehaul: nullCheck(data, undefined, "movements", "0", "override_pay_amt_n"),
      payeeId: nullCheck(data, undefined, "movements", "0", "override_payee_id"),
      customerName: nullCheck(data, undefined, "customer", "name"),
      accountManager: data.or_user_id1,
      operationsRep: data.or_user_id2,
      salesRep: data.cr_user_id,
      movementId: data.curr_movement_id,
      settlementDate: nullCheck(data, null, "movements", "0", "xfer2settle_date"),
      originCity: nullCheck(data, null, "stops", "0", "city_name"),
      originState: nullCheck(data, null, "stops", "0", "state"),
      originArriveEarly: parseMcleodDate(nullCheck(data, null, "stops", "0", "sched_arrive_early")),
      originArriveLate: parseMcleodDate(nullCheck(data, null, "stops", "0", "sched_arrive_late")),
      destinationCity: data.stops[data.stops.length - 1] ? data.stops[data.stops.length - 1].city_name : null,
      destinationState: data.stops[data.stops.length - 1] ? data.stops[data.stops.length - 1].state : null,
      destinationArriveEarly: data.stops[data.stops.length - 1] ? parseMcleodDate(data.stops[data.stops.length - 1].sched_arrive_early) : null,
      destinationArriveLate: data.stops[data.stops.length - 1] ? parseMcleodDate(data.stops[data.stops.length - 1].sched_arrive_late) : null,
      movements: data.movements ? data.movements.map(m => MovementSerializer.deSerialize(m)) : [],
      equipmentTypeId: data.equipment_type_id,
      tender: data.tender_type,
      shipper: nullCheck(data, null, "stops", "0", "location_name"),
      totalCharge: data.total_charge,
      billDate: data.bill_date,
      consigneeRefNum: data.consignee_refno,
      dateEntered: data.ordered_date,
      freightCharge: data.freight_charge,
      cargoValue: data.order_value
    };
  }
}